import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {
    fetchCustomerProfile,
    getComplainceDocument,
    getJobCardDetails, payCustomerDues,
    unAssignAssetForCustomer, uploadCustomerPhoto,
    uploadLoanDocument,
} from "../../Api/Api";
import LoanModal from "../Loan/LoanModal";
import AssetAssignModal from "../Asset/AssetAssignModal";
import BillingModal from "../Billing/BillingModal";
import {FaCamera, FaEdit, FaEye, FaStop, FaUpload, FaUserCheck} from "react-icons/fa";
import JobCardDetailsModal from "../Jobcard/JobCardDetailsModal";
import {useNotification} from "../Notification/NotificationContext";
import UploadComplianceModal from "../Asset/UploadComplianceModal";
import ConfirmUnassignAssetModal from "../Asset/ConfirmUnassignAssetModal";
import ComplianceDocumentsModal from "../Asset/ComplianceDocumentsModal";
import LoyaltyCardModal from "../LoyaltyCard/LoyaltyCardModal";
import PayDuesModal from "./PayDuesModal";

const CustomerProfilePage = () => {
    const { customerId } = useParams();
    const [data, setData] = useState(null);
    const [showLoanModal, setShowLoanModal] = useState(false);
    const [showAssetModal, setShowAssetModal] = useState(false);
    const [selectedJobCard, setSelectedJobCard] = useState(null);
    const [showBillModal, setShowBillModal] = useState(null);
    const navigate = useNavigate();

    const [refresh, setRefresh] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(null);
    const [jobCardDetails, setJobCarddDetails] = useState(null);
    const { showNotification } = useNotification();
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [showUnassignModal, setShowUnassignModal] = useState(false);
    const [isComplianceModalOpen, setComplianceModalOpen] = useState(false);
    const [selectedAssetDocuments, setSelectedAssetDocuments] = useState([]);
    const [showLoyaltyCardModal, setShowLoyaltyCardModal] = useState(false);
    const [showPayDuesModal, setShowPayDuesModal] = useState(false);

    const loadData = async () => {
        const data = await fetchCustomerProfile(customerId);
        setData(data.data);
    };

    useEffect(() => {
        loadData();
    }, [customerId,refresh]);

    const handleOpenUploadModal = (asset) => {
        setSelectedAsset(asset);
        setShowUploadModal(true);
    };

    const handleCloseUploadModal = () => {
        setSelectedAsset(null);
        setShowUploadModal(false);
    }

    const handleBillModalOpen = (jobCard) => {
        setShowBillModal(true);
        setSelectedJobCard(jobCard)
        setRefresh(false)
    }

    const handleBillModalClose = () => {
        setShowBillModal(false);
        setRefresh(true)
    }

    const fetchJobCardDetails = (jobCardId) => {

            getJobCardDetails(jobCardId)
            .then((response) => {
                setJobCarddDetails(response.data);
            })
            .catch((error) => {
                showNotification(error.message, "error")
            });
    }

    const handleViewDetails = async (jobCardId) => {
        fetchJobCardDetails(jobCardId);
        setShowDetailModal(true)
    };

    const handleCloseDetails = () => {
        setShowDetailModal(false)
    }

    const handleUnassignClick = (asset) => {
        setSelectedAsset(asset);
        setShowUnassignModal(true);
    };

    const handleUnassignConfirmed = () => {
        unAssignAssetForCustomer(selectedAsset.assetId).then(r =>  setSelectedAsset(null));
        loadData();
    }

    const openComplianceModal = async (asset) => {
        const response = await getComplainceDocument(asset.assetId);
        setSelectedAssetDocuments(response.data);
        setComplianceModalOpen(true);
    };

    const handlePhotoUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("photo", file);
        formData.append("customerId", data.id);

        uploadCustomerPhoto(customerId, formData)
            .then((response) => {
                showNotification("Uploaded Successfully!", "success")
                fetchCustomerProfile(customerId);
            })
            .catch((error) => showNotification(error.message, "error"));
    };

    const handleShowLoyaltyCardModalClose = () => {
        setShowLoyaltyCardModal(false);
    };


    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <div className="max-w-7xl mx-auto space-y-6">

                {/* Header Profile Card */}<div className="bg-white p-6 rounded-xl shadow flex flex-col md:flex-row items-center gap-6">
                <div className="relative">
                    <img
                        className="w-24 h-24 rounded-full border-4 border-indigo-500 object-cover"
                        src={data?.profileImage || "https://i.pravatar.cc/150"}
                        alt="Customer"
                    />
                    <label htmlFor="upload-photo">
                        <div className="absolute bottom-0 right-0 bg-indigo-600 hover:bg-indigo-700 text-white p-1 rounded-full cursor-pointer shadow-lg transition">
                            <FaCamera className="w-4 h-4" />
                        </div>
                    </label>
                    <input
                        id="upload-photo"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handlePhotoUpload}
                    />
                </div>

                <div className="flex-1">
                    <h2 className="text-2xl font-semibold text-gray-800">
                        {data?.customerName || "Customer Name"}
                    </h2>
                    <p className="text-sm text-gray-500">Customer • India</p>
                    <div className="mt-3 text-sm text-gray-700 space-y-1">
                        <p>📧 {data?.email || "No email"}</p>
                        <p>📞 +91 - {data?.customerPhone || "No phone"}</p>
                    </div>
                    {/* ✅ Loyalty Card Info */}
                    {/* ✅ Loyalty Card Info */}
                    {data?.loyaltyCard ? (
                        <div className="mt-4 bg-yellow-100 border border-yellow-300 p-3 rounded-lg">
                            <p className="text-yellow-800 font-semibold">🌟 Gold Card Member</p>
                            <p className="text-sm text-gray-700">
                                Valid till: {new Date(data.loyaltyCard.expiryDate).toLocaleDateString()}
                            </p>
                            <p className="text-sm text-gray-700">
                                Free services left: {12 - data.loyaltyCard.serviceCountUsed}
                            </p>
                            <p className="text-sm text-gray-700">
                                Loyalty Points: {data.loyaltyCard.loyaltyPointsBalance}
                            </p>

                            {/* ✅ Renew button if expired OR all free services used */}
                            {(new Date(data.loyaltyCard.expiryDate) < new Date() ||
                                data.loyaltyCard.serviceCountUsed >= 12) && (
                                <button
                                    onClick={() => setShowLoyaltyCardModal(true)}
                                    className="mt-3 bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg text-sm"
                                >
                                    Renew Gold Card
                                </button>
                            )}
                        </div>
                    ) : (
                        <div className="mt-4 flex flex-wrap gap-3">
                            <button
                                onClick={() => setShowLoyaltyCardModal(true)}
                                className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg text-sm"
                            >
                                Purchase Loyalty Card
                            </button>
                        </div>
                    )}
                    <div className="mt-4 flex flex-wrap gap-3">
                        <button
                            onClick={() => setShowLoanModal(true)}
                            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm"
                        >
                            Request Loan
                        </button>
                        <button
                            onClick={() => setShowAssetModal(true)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm"
                        >
                            Assign Asset
                        </button>

                    </div>

                </div>
                {data?.customerAccount && (
                    <div className="mt-4 bg-red-100 border border-red-300 p-3 rounded-lg">
                        <p className="text-red-800 font-semibold">
                            Outstanding Balance: ₹ {data.customerAccount.balance.toFixed(2)}
                        </p>

                        {data?.customerAccount?.balance > 0 && (
                            <button
                                onClick={() => setShowPayDuesModal(true)}
                                className="mt-3 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm"
                            >
                                Pay Dues
                            </button>
                        )}
                    </div>
                )}
            </div>
                {/* Personal Info Block */}
                <div className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                        Personal Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
                        <div>
                            <p className="font-medium">Name</p>
                            <p>{data?.customerName || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-medium">Phone</p>
                            <p>+91 - {data?.customerPhone || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-medium">Email</p>
                            <p>{data?.email || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-medium">Customer ID</p>
                            <p>{customerId}</p>
                        </div>
                    </div>
                </div>

                {/* Assigned Assets */}
                {/* Assigned Assets Table */}
                <div className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                        Assigned Assets
                    </h3>
                    {data?.assignedAssets?.length > 0 ? (
                        <table className="w-full text-sm text-gray-700">
                            <thead className="bg-gray-100 text-gray-600">
                            <tr>
                                <th className="text-left py-2 px-3">Type</th>
                                <th className="text-left py-2 px-3">Serial Number</th>
                                <th className="text-left py-2 px-3">Assigned Date</th>
                                <th className="text-left py-2 px-3">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.assignedAssets.map((asset, index) => (
                                <tr key={index} className="border-t">
                                    <td className="py-2 px-3">{asset.type}</td>
                                    <td className="py-2 px-3">{asset.serialNumber}</td>
                                    <td className="py-2 px-3">{new Date(asset.assignedDate).toLocaleDateString()}</td>
                                    <td className="py-2 px-3 space-x-2 flex">
                                        <button
                                            className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded flex items-center transition"
                                            onClick={() => handleOpenUploadModal(asset)}
                                        >
                                            <FaUpload/> Upload Doc
                                        </button>
                                        <button
                                            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded flex items-center transition"
                                            onClick={() => handleUnassignClick(asset)}
                                        >
                                          <FaStop/>  UnAssign
                                        </button>
                                        <button
                                            onClick={() => openComplianceModal(asset)}
                                            className="bg-blue-400 text-white px-3 py-1 rounded-md flex items-center hover:bg-blue-500"
                                        >
                                            View Documents
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-gray-500">No assets assigned.</p>
                    )}
                </div>


                {/* Loans */}
                <div className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                        Customer Loans
                    </h3>
                    {data?.loans?.length > 0 ? (
                        <table className="w-full text-sm text-gray-700">
                            <thead className="bg-gray-100 text-gray-600">
                            <tr>
                                <th className="text-left py-2 px-3">Loan ID</th>
                                <th className="text-left py-2 px-3">Amount</th>
                                <th className="text-left py-2 px-3">Pending Principle</th>
                                <th className="text-left py-2 px-3">Pending EMIs</th>
                                <th className="text-left py-2 px-3">Status</th>
                                <th className="text-left py-2 px-3">Loan Details</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.loans.map((loan) => (
                                <tr key={loan.id} className="border-t">
                                    <td className="py-2 px-3">#{loan.loanId}</td>
                                    <td className="py-2 px-3">₹ {loan.principalAmount}</td>
                                    <td className="py-2 px-3">₹ {loan.pendingPrincipleAmount}</td>
                                    <td className="py-2 px-3">{loan.pendingEmis}</td>
                                    <td className="py-2 px-3">{loan.status}</td>
                                    <td className="py-2 px-3">
                                        <button
                                            className="bg-teal-400 text-white px-4 py-2 rounded-md flex items-center hover:bg-teal-500"
                                            onClick={() => navigate(`/loans/${loan.loanId}`)}
                                        >
                                            <FaEye />
                                            <span className="ml-2">View</span>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-gray-500">No loans found.</p>
                    )}
                </div>
                <div className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                        Visit History
                    </h3>
                    {data?.visits?.length > 0 ? (
                        <table className="w-full text-sm text-gray-700">
                            <thead className="bg-gray-100 text-gray-600">
                            <tr>
                                <th className="text-left py-2 px-3">Job Card</th>
                                <th className="text-left py-2 px-3">Date</th>
                                <th className="text-left py-2 px-3">Purpose</th>
                                <th className="text-left py-2 px-3">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.visits.map((visit, index) => (
                                <tr key={index} className="border-t">
                                    <td className="py-2 px-3">#{visit.jobCard.jobCardId}</td>
                                    <td className="py-2 px-3">{new Date(visit.visitDate).toLocaleDateString()}</td>
                                    <td className="py-2 px-3">{visit.purpose}</td>
                                    <td className="py-2 px-3 space-x-2 flex">
                                        <button
                                            className="bg-yellow-500 text-white px-3 py-1 rounded flex items-center hover:bg-yellow-600 transition"
                                            onClick={() => handleViewDetails(visit?.jobCard.jobCardId)}
                                        >
                                            <FaEdit className="mr-1" /> Details
                                        </button>
                                        { (visit?.jobCard?.billStatus !== "PENDING" && visit?.jobCard?.billStatus !== "PAID" && visit?.jobCard?.status ==="COMPLETED")
                                            && (
                                                <button
                                            className="bg-purple-500 text-white px-3 py-1 rounded flex items-center hover:bg-purple-600 transition"
                                            onClick={() => handleBillModalOpen(visit?.jobCard)}
                                        >
                                            <FaUserCheck className="mr-1" /> Generate Bill
                                        </button>
                                            )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-gray-500">No visit history found.</p>
                    )}
                </div>
            </div>
            <LoanModal
                show={showLoanModal}
                customerId={customerId}
                onClose={() => setShowLoanModal(false)}
            />
            <AssetAssignModal
                show={showAssetModal}
                onAssign={() => setShowAssetModal(false)}
                onClose={() => setShowAssetModal(false)}
                customerId={customerId}
            />
            <JobCardDetailsModal
                show={showDetailModal}
                handleClose={handleCloseDetails}
                selectedJobCard={jobCardDetails}
            />
            {showBillModal && (
                <BillingModal
                    jobCard={selectedJobCard}
                    customer={data}   // ✅ pass full customer with loyaltyCard
                    show={showBillModal}
                    handleClose={handleBillModalClose}
                />
            )}
            <UploadComplianceModal
                show={showUploadModal}
                asset={selectedAsset}
                onClose={handleCloseUploadModal}
                customerId={customerId}
            />
            <ConfirmUnassignAssetModal
                show={showUnassignModal}
                asset={selectedAsset}
                onClose={() => setShowUnassignModal(false)}
                onConfirm={handleUnassignConfirmed}
            />
            <ComplianceDocumentsModal
                isOpen={isComplianceModalOpen}
                onClose={() => setComplianceModalOpen(false)}
                documents={selectedAssetDocuments}
            />

            {/* ✅ New Loyalty Card Modal */}
            <LoyaltyCardModal
                show={showLoyaltyCardModal}
                customerId={customerId}
                onClose={() => setShowLoyaltyCardModal(false)}
                onSuccess={loadData}
                existingCard={data?.loyaltyCard} // ✅ decides purchase vs renew
            />

            <PayDuesModal
                show={showPayDuesModal}
                balance={data?.customerAccount?.balance || 0}
                onClose={() => setShowPayDuesModal(false)}
                onConfirm={(amount) => {
                    // Call backend to apply FIFO payments
                    payCustomerDues(customerId, amount)
                        .then(() => {
                            showNotification("Payment successful", "success");
                            setShowPayDuesModal(false);
                            loadData(); // refresh profile
                        })
                        .catch((err) => showNotification(err.message, "error"));
                }}
            />
        </div>
    );
};

export default CustomerProfilePage;
